__turbopack_context__.v({
  "arrowLeft": "ButtonLink-module-scss-module__JBtFvG__arrowLeft",
  "arrowRight": "ButtonLink-module-scss-module__JBtFvG__arrowRight",
  "blackText": "ButtonLink-module-scss-module__JBtFvG__blackText",
  "btn": "ButtonLink-module-scss-module__JBtFvG__btn",
  "btnMark": "ButtonLink-module-scss-module__JBtFvG__btnMark",
  "btnNoBorder": "ButtonLink-module-scss-module__JBtFvG__btnNoBorder",
  "fadeInOut": "ButtonLink-module-scss-module__JBtFvG__fadeInOut",
});
